import axios from '../config'
import { DigitalTextbookServer } from '../baseURL'
import { STORE_ID } from '@/config/constant'

export default {
  storeFindOne() {
    return axios.get(`${DigitalTextbookServer}/store/store/${STORE_ID}`)
  },
  storeBookFind() {
    return axios.get(`${DigitalTextbookServer}/storeBook/list?fk_store_id=${STORE_ID}&status=1`)
  },
  storeBookFindOne(bookId) {
    return axios.get(`${DigitalTextbookServer}/storeBook/storeBook/${bookId}`)
  },
  storeClassFindByCode(invitation_code) {
    return axios.get(`${DigitalTextbookServer}/bookClass/findByCode?invitation_code=${invitation_code}`)
  },
  bookUserUpdate(data) {
    return axios.post(`${DigitalTextbookServer}/bookUser/newbookUser`, data)
  },
  bookUserJoinClass(data) {
    return axios.post(`${DigitalTextbookServer}/bookUser/joinClass`, data)
  },
  getFileContent(url) {
    return axios.get(url)
  }
}